import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import ReactStars from 'react-rating-stars-component';
import { debounce } from 'lodash';
import APIService from '../../shared/services/api';
import Notify from '../../shared/notify';
import TextInput from '@shared/component/TextInput';
import List from '@shared/component/List';
import { AuthContext } from '@shared/context/AuthContext';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import CustomDateTimePicker from '@shared/component/DatePicker';
import CheckValidator from '@shared/checkValidator';
import Lists from '@shared/component/Lists';
import { DateFormatPicker, TextTruncate } from '@utils/static/commonUtils';
import CommonRatingModal from './ratingModel';
import OtherDemandView from './otherDemandViewModel';
import { actionsPermissionValidator, ActionValues } from '@utils/static/commonUtils';

export function FinalisedBidsOthers() {
    const [formData, setFormData] = useState<any>({
        status: null,
        DeliveryDate: null,
        ontime: null,
    });
    const [errors, setError] = useState<any>({
        status: {
            required: true,
            error: true,
            message: 'Please select',
        },
        DeliveryDate: {
            required: true,
            error: true,
            message: 'Please select date',
            min: new Date().toISOString().slice(0, 16),
        },
        ontime: {
            required: true,
            error: true,
            message: 'Please select',
        },
    });
    const listRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [FinalisedBids, setFinalisedBids] = useState([]);
    const [id, setId] = useState(null);
    const [bidData, setBidData] = useState('');
    const [viewdata, setViewData] = useState([]);
    const [demandDetail, setDemandDetail] = useState([]);
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [demandModel, setDemandModel] = useState(false);
    const [viewModel, setViewModel] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [showHideModel, setShowHideModel] = useState(false);
    const [pickupdate, setPickupDate] = useState(Date.now());
    const [isSubmit, setIsSubmit] = useState(false);
    const params: any = useParams();
    const [edit, setedit] = useState(false);
    const [columns, setColumns] = useState({
        id: 'ID',
        'app_user.name': 'Vendor Name',
        'app_user.phone': 'Phone No',
        'demand.category.name': 'Category Name',
        'demand.item.name': 'Item Name',
        deliveryStatus: 'Delivery Status',
        actualDeliveryDate: 'Arrival Date & Time',
        remark: 'Remarks',
        action: 'Action',
    });
    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
        } catch (error) {}
    };
    const handleShowDemandModal = id => {
        const data: any = FinalisedBids.filter((item: any) => item.id == id);
        setViewData(data[0]);
        setDemandModel(true);
    };

    const searchItem = async (search: any, page: any) => {
        try {
            // setLoader(true);
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `bid/search?page=${page}&order=desc&sort=createdAt&search=${search}`,
                true,
                false,
            );
            setLoader(false);
            setFinalisedBids(data?.data?.data);
            setRecordCount(data.data.count);
        } catch (err) {
            setLoader(false);
        } finally {
            setLoader(false);
        }
    };
    const getValue = (e: any) => {
        try {
            const data = { ...formData, ...e };
            setFormData(data);
        } catch (error) {}
    };

    const getFinalisedBids = async (page: any = 1) => {
        try {
            setCurrentPage(page);
            setLoader(true);
            const data = await APIService.getAll(`bid/finalisedbids?page=${page}&sort=createdAt`, true, false);
            setRecordCount(data?.data?.count);
            setFinalisedBids(data?.data?.data);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    const handelViewModel = (flag: boolean) => {
        try {
            setViewModel(flag);
        } catch (error) {}
    };
    const handleShowRatingModal = () => {
        setShowRatingModal(true);
    };

    const handleHideRatingModal = () => {
        setShowRatingModal(false);
    };
    const handleRatingSubmit = async ({ rating, remarks }) => {
        // Handle the submitted rating and remarks
        if (rating == 0) {
            Notify('error', 'Please select rating');
            return;
        }

        try {
            const data = {
                rating,
                remark: remarks,
                appUserId: viewdata?.appUserId,
                bidId: viewdata?.id,
            };
            setLoader(true);
            const updateddata = await APIService.post('rating/', data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                handleHideRatingModal();
                getFinalisedBids();
            }
        } catch (error) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getFinalisedBids();
        handlereset();
    }, []);

    const updateStatus = async (item: any, status: any, id: any) => {};

    const getFinalisedBidsById = async (id: any, type) => {
        setId(id);
        setedit(true);
        let data: any = FinalisedBids.filter((item: any) => item.id == id);
        setDemandDetail(data[0].demand);
        setViewData(data[0]);
        setBidData(data[0].deliveryStatus);
        if (type == 'rating') {
            handleShowRatingModal();

            return;
        }
        if (type == 'view') {
            handelViewModel(true);
            return;
        }
        setPickupDate(data[0].demand?.pickUpDate);
        if (data.length > 0) {
            data = data[0];
            if (data?.deliveryStatus == 'notArrived') {
                setFormData({
                    ['status']: data?.deliveryStatus,
                    ['ontime']: null,
                    ['DeliveryDate']: null,
                });
            } else {
                if (data) {
                    // const value = convertDateTime(data, 'actualDeliveryDate', 330);
                    setFormData({
                        ['status']: data?.deliveryStatus,
                        ['ontime']: data?.isOnTime,
                        ['DeliveryDate']: data.DeliveryDate || null,
                    });
                }
            }
        }
        handelModel(true);
    };

    const handlereset = () => {
        setFormData({
            ['status']: null,
            ['ontime']: null,
            ['DeliveryDate']: null,
        });
        setIsSubmit(false);
        setedit(false);
        handelModel(false);
    };

    const updateBidStatus = async () => {
        try {
            if (formData.status == null) {
                Notify('error', 'Please select delivery status');
            } else {
                if (formData.status == 'notArrived') {
                    delete formData.ontime;
                    delete formData.DeliveryDate;
                }
                const isValid = await CheckValidator(errors, formData);
                setIsSubmit(!isValid);

                if (isValid) {
                    let data = {};
                    if (formData.status == 'notArrived') {
                        data = {
                            deliveryStatus: formData.status,
                            isOnTime: null,
                            DeliveryDate: null,
                        };
                    } else {
                        if (new Date(viewdata?.demand?.cutOffTime) > new Date(formData.DeliveryDate)) {
                            Notify('error', 'Please choose after cut of time');
                            return;
                        }
                        data = {
                            deliveryStatus: formData.status,
                            ontime: formData.ontime,
                            DeliveryDate:
                                formData.DeliveryDate != null || formData != '' ? formData.DeliveryDate : null,
                        };
                    }

                    if (formData.status == 'delivered' && !moment().isAfter(formData.DeliveryDate)) {
                        Notify('error', 'Future time can`t be select');
                        return;
                    }

                    setLoader(true);

                    const updateddata = await APIService.update('bid', id, data, true, true);
                    setLoader(false);
                    if (updateddata.status === 200) {
                        Notify('success', 'Bid Status updated successfully');

                        handelModel(false);
                        setedit(false);
                        handlereset();
                        getFinalisedBids(currentPage);
                    } else {
                        Notify('error', updateddata.data.message);
                    }
                }
            }
        } catch (err) {
            Notify('error', err.response.data.message);
            setLoader(false);
        }
    };

    function formatDate(dateString) {
        return moment(dateString).format('DD MMM YYYY | hh.mm A');
    }

    const startDeliveryDate = moment(demandDetail?.cutOffTime);
    const formatedStartDeliveryDate = startDeliveryDate.format('YYYY-MM-DD');

    const currentDate = moment();
    const formattedCurrentDate = currentDate.format('YYYY-MM-DD');

    const formattedDate = new Date(viewdata?.demand?.pickUpDate).toLocaleString();
    const formattedDateDelivery = new Date(viewdata?.expectedDeliveryDate).toLocaleString();

    const filterPassedTime = (time, type) => {
        try {
            const cdate = moment();
            const selectedDate = new Date(time);
            const cutOffDate = moment(demandDetail?.cutOffTime);

            // if (cutOffDate.isBefore(cdate)) {
            //     const currentDate = new Date();
            //     return currentDate.getTime() > selectedDate.getTime();
            // }

            if (type == 'delivery_date') {
                const currentDate = new Date(demandDetail?.cutOffTime);
                return currentDate.getTime() < selectedDate.getTime();
            }
        } catch (error) {}
    };

    const calculateMaxDate = type => {
        try {
            // console.log('type', type)
            if (type == 'arrive_date' || type == 'dispatch_date' || type == 'delivery_date') {
                const currentDate = moment();
                const deliveryDate = moment(demandDetail?.deliveryDate);
                if (deliveryDate.isAfter(currentDate)) {
                    return currentDate;
                } else {
                    return currentDate;
                }
            }
        } catch (error) {}
    };

    const deliveryModel = () => {
        return (
            <>
                <div className="material_form_cover">
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                        }}
                    >
                        <div className="field_box">
                            <h3>
                                <b>Delivery Status</b>
                            </h3>
                            <div className="check_field_box mb-4">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="flexRadioDefault1"
                                        value={'delivered'}
                                        onChange={e => {
                                            setFormData({
                                                ...formData,
                                                ['status']: e.target.value,
                                            });
                                            getValue({ status: e.target.value });
                                            errors['DeliveryDate'] = {
                                                required: true,
                                                error: true,
                                                message: 'Please select date',
                                                min: new Date().toISOString().slice(0, 16),
                                            };
                                            errors['status'] = {
                                                required: true,
                                                error: false,
                                                message: 'Please select',
                                            };
                                            setError(errors);
                                        }}
                                        checked={formData.status === 'delivered' ? true : false}
                                        disabled={bidData === 'delivered' || bidData === 'notArrived'}
                                    />
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                        Delivered
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="flexRadioDefault2"
                                        value={'notArrived'}
                                        onChange={e => {
                                            setFormData({
                                                ...formData,
                                                ['status']: e.target.value,
                                            });
                                            getValue({ status: e.target.value });
                                            delete errors.DeliveryDate;
                                            errors['status'] = {
                                                required: true,
                                                error: false,
                                                message: 'Please select',
                                            };
                                            setError(errors);
                                        }}
                                        checked={formData.status === 'notArrived' ? true : false}
                                        disabled={bidData === 'delivered' || bidData === 'notArrived'}
                                    />
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                        Not Arrived
                                    </label>
                                </div>
                                {errors?.status?.required && errors?.status?.error && isSubmit && (
                                    <div className="text-danger ft-12"> {errors?.status.message}</div>
                                )}
                            </div>
                            <div className="row">
                                {formData?.status === 'delivered' ? (
                                    <>
                                        <div className="col-sm-12">
                                            <div className="form-floating" style={{ fontSize: 14 }}>
                                                Commited Delivery Date & Time{' '}
                                                {formatDate(viewdata?.expectedDeliveryDate)}
                                            </div>
                                            <div className="form-floating">
                                                <CustomDateTimePicker
                                                    data={{
                                                        name: 'DeliveryDate',
                                                        placeholder: 'Select Delivery Date & Time',
                                                        id: 'floatingInput',
                                                        label: 'Select Delivery Date & Time',
                                                        date: pickupdate,
                                                    }}
                                                    minDate={formatedStartDeliveryDate}
                                                    // maxDate={formattedCurrentDate}
                                                    maxDate={calculateMaxDate('delivery_date')}
                                                    controlName="DeliveryDate"
                                                    isSubmit={isSubmit}
                                                    value={formData?.DeliveryDate != null ? formData?.DeliveryDate : ''}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.DeliveryDate.message}
                                                    inputProps={errors}
                                                    filterPassedTime={time => filterPassedTime(time, 'delivery_date')}
                                                />
                                            </div>
                                        </div>
                                        <h3>
                                            <b>Was delivery on time?</b>
                                        </h3>

                                        <div className="check_field_box mb-4">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaulttime"
                                                    id="flexRadioDefaulttime3"
                                                    value={'yes'}
                                                    onChange={e => {
                                                        setFormData({
                                                            ...formData,
                                                            ['ontime']: true,
                                                        });
                                                        getValue({ ontime: true });
                                                        errors['ontime'] = {
                                                            required: true,
                                                            error: false,
                                                            message: 'Please select',
                                                        };
                                                        setError(errors);
                                                    }}
                                                    checked={formData.ontime}
                                                    disabled={bidData === 'delivered' || bidData === 'notArrived'}
                                                />
                                                <label className="form-check-label" htmlFor="flexRadioDefaulttime3">
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaulttime"
                                                    id="flexRadioDefaulttime4"
                                                    value={'no'}
                                                    onChange={e => {
                                                        setFormData({
                                                            ...formData,
                                                            ['ontime']: false,
                                                        });
                                                        getValue({ ontime: false });
                                                        errors['ontime'] = {
                                                            required: true,
                                                            error: false,
                                                            message: 'Please select',
                                                        };
                                                        setError(errors);
                                                    }}
                                                    checked={formData.ontime !== null && !formData.ontime}
                                                />
                                                <label className="form-check-label" htmlFor="flexRadioDefaulttime4">
                                                    No
                                                </label>
                                            </div>
                                            {errors?.ontime?.required && errors?.ontime?.error && isSubmit && (
                                                <div className="text-danger ft-12"> {errors?.ontime.message}</div>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </>
        );
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Finalised Bids Others</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    <List
                        ref={listRef}
                        headTitles={[
                            'Demand Id',
                            'Bid Id',
                            'Vendor Name',
                            'Phone No.',
                            'Category Name',
                            'Item Name',
                            'Status',
                            'Rating',
                        ]}
                        type={'finalised_other_vendor'}
                        tab={'vendor...'}
                        searchItem={searchItem}
                        list={FinalisedBids}
                        getById={getFinalisedBidsById}
                        updateStatus={updateStatus}
                        otherdemandModel={handleShowDemandModal}
                        addUpdateText="Demand"
                        addModel="add_model"
                        editModel="edit_model"
                        callPagination={getFinalisedBids}
                        recordCount={recordCount}
                        helperText={'Search By Vendor Name ,Phone No.,Category Name,Item Name'}
                    />
                </div>
                {
                    <CommonRatingModal
                        show={showRatingModal}
                        onHide={handleHideRatingModal}
                        onRatingSubmit={handleRatingSubmit}
                    />
                }

                {viewModel && (
                    <Modal
                        scrollable={true}
                        show={true}
                        onHide={() => handelViewModel(false)}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>View</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="material_form_cover stepper_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    {bidData == 'notArrived' ? (
                                        <>
                                            <div className="custom_row">
                                                <div className="col_left_box">
                                                    <div className="mid_dot_line"></div>
                                                </div>

                                                <div className="col_right_box">
                                                    <div className="field_box">
                                                        <h3 className="head_box_cover">
                                                            <span className="head_box">1</span>
                                                            <b>Not Arrived</b>
                                                        </h3>
                                                        <br></br>
                                                        <h3>
                                                            <b>Delivery Status</b>
                                                        </h3>
                                                        <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault1"
                                                                    value={'delivered'}
                                                                    checked={viewdata?.deliveryStatus === 'delivered'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault1"
                                                                >
                                                                    Delivered
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault2"
                                                                    value={'notArrived'}
                                                                    checked={viewdata?.deliveryStatus === 'notArrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault2"
                                                                >
                                                                    Not Arrived
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {viewdata.rating_appUser == null ? (
                                                actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                                    <>
                                                        <div className="form-floating">
                                                            <h3>
                                                                <b>Vendor Rating</b>
                                                            </h3>

                                                            <Button
                                                                className="btn rateNowblue_btn custom_btn"
                                                                onClick={() => {
                                                                    handleShowRatingModal();
                                                                    setedit(true);
                                                                    handelViewModel(false);
                                                                }}
                                                            >
                                                                Rate Vendor
                                                            </Button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    ''
                                                )
                                            ) : viewdata?.rating_appUser !== null ? (
                                                <>
                                                    <>
                                                        <div className="col-sm-12">
                                                            <div className="form-floating">
                                                                <h3 style={{ marginBottom: '0px' }}>
                                                                    <b>Vendor Rating</b>
                                                                </h3>
                                                                <ReactStars
                                                                    count={5}
                                                                    value={viewdata?.rating_appUser?.rating}
                                                                    size={25}
                                                                    isHalf={true}
                                                                    edit={false}
                                                                    activeColor="#ffd700"
                                                                />
                                                            </div>

                                                            <div className="form-floating">
                                                                {viewdata?.rating_appUser?.remark && (
                                                                    <div className="form-floating">
                                                                        <input
                                                                            id="remarks"
                                                                            className="form-control"
                                                                            placeholder="Remark"
                                                                            value={viewdata?.rating_appUser?.remark}
                                                                            disabled={true}
                                                                        />
                                                                        <label htmlFor="floatingInput">Remarks</label>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    ) : bidData == 'cancelled' ? (
                                        <>
                                            <div className="custom_row">
                                                <div className="col_left_box">
                                                    <div className="mid_dot_line"></div>
                                                </div>
                                                <div className="col_right_box">
                                                    <div className="field_box">
                                                        <h3 className="head_box_cover">
                                                            <span className="head_box">1</span>
                                                            <b>Vendor Denied</b>
                                                        </h3>
                                                        <br></br>
                                                        <h3>
                                                            <b>Delivery Status</b>
                                                        </h3>
                                                        <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault1"
                                                                    value={'arrived'}
                                                                    checked={viewdata?.deliveryStatus === 'delivered'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault1"
                                                                >
                                                                    Delivered
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault2"
                                                                    value={'notArrived'}
                                                                    checked={viewdata?.deliveryStatus === 'notArrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault2"
                                                                >
                                                                    Not Arrived
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault2"
                                                                    value={'notArrived'}
                                                                    checked={viewdata?.deliveryStatus === 'cancelled'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault2"
                                                                >
                                                                    Cancelled
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <h3 className="head_box_cover">
                                                            <b>Reason for cancelled</b>
                                                        </h3>
                                                        <div className="form-floating">
                                                            <input
                                                                id="remarks"
                                                                className="form-control"
                                                                placeholder="Reason"
                                                                value={viewdata?.reason}
                                                                disabled={true}
                                                            />
                                                            <label htmlFor="floatingInput">Reason</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {viewdata.rating_appUser == null ? (
                                                <>
                                                    <div className="form-floating">
                                                        <h3>
                                                            <b>Transporter Rating</b>
                                                        </h3>

                                                        <Button
                                                            className="btn rateNowblue_btn custom_btn"
                                                            onClick={() => {
                                                                handleShowRatingModal();
                                                                setedit(true);
                                                                handelViewModel(false);
                                                            }}
                                                        >
                                                            Rate Transporter
                                                        </Button>
                                                    </div>
                                                </>
                                            ) : viewdata?.rating_appUser !== null ? (
                                                <>
                                                    <>
                                                        <div className="col-sm-12">
                                                            <div className="form-floating">
                                                                <h3 style={{ marginBottom: '0px' }}>
                                                                    <b>Transporter Rating</b>
                                                                </h3>
                                                                <ReactStars
                                                                    count={5}
                                                                    value={viewdata?.rating_appUser?.rating}
                                                                    size={25}
                                                                    isHalf={true}
                                                                    edit={false}
                                                                    activeColor="#ffd700"
                                                                />
                                                            </div>

                                                            <div
                                                                className="form-floating"
                                                                style={{ marginTop: '15px' }}
                                                            >
                                                                {viewdata?.rating_appUser?.remark && (
                                                                    <div className="form-floating">
                                                                        <input
                                                                            id="remarks"
                                                                            className="form-control"
                                                                            placeholder="Remark"
                                                                            value={viewdata?.rating_appUser?.remark}
                                                                            disabled={true}
                                                                        />
                                                                        <label htmlFor="floatingInput">Remarks</label>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {/* stepper start */}

                                            <div className="custom_row">
                                                <div className="col_left_box">
                                                    <div className="mid_dot_line"></div>
                                                </div>

                                                <div className="col_right_box w-100">
                                                    <div className="field_box">
                                                        <h3 className="head_box_cover">
                                                            <span className="head_box">1</span>
                                                            <b>Delivered</b>
                                                        </h3>
                                                        {/* <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime5"
                                                                    id="flexRadioDefaulttime5"
                                                                    value={'yes'}
                                                                    checked={viewdata?.deliveryStatus === 'arrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime5"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime"
                                                                    id="flexRadioDefaulttime6"
                                                                    value={'no'}
                                                                    checked={viewdata?.deliveryStatus === 'notArrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime6"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div> */}
                                                        <div className="col-sm-12">
                                                            <div className="form-floating d-flex">
                                                                <div style={{ fontSize: 14 }}>
                                                                    Commited Delivery Date & Time
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginLeft: 10,
                                                                        fontWeight: 500,
                                                                    }}
                                                                >
                                                                    {formatDate(viewdata?.demand?.pickUpDate)}
                                                                </div>
                                                            </div>

                                                            <div className="form-floating">
                                                                <CustomDateTimePicker
                                                                    data={{
                                                                        name: 'DeliveryDate',
                                                                        placeholder: 'Select Delivery Date & Time',
                                                                        id: 'floatingInput',
                                                                        label: 'Vehical Delivery Date & Time',
                                                                        date: formattedDate,
                                                                    }}
                                                                    controlName="DeliveryDate"
                                                                    isSubmit={isSubmit}
                                                                    value={viewdata?.deliveredDeliveryDate}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <br></br>
                                                        <h3>
                                                            <b>Was delivered on time?</b>
                                                        </h3>
                                                        <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime"
                                                                    id="flexRadioDefaulttime3"
                                                                    value={true}
                                                                    checked={viewdata?.isOnTime === true}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime3"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>

                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime"
                                                                    id="flexRadioDefaulttime4"
                                                                    value={'no'}
                                                                    checked={viewdata?.isOnTime === false}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime4"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* end of stepper */}

                                            {(bidData == 'delivered' || bidData == 'arrived') &&
                                            viewdata.rating_appUser == null ? (
                                                actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                                    <>
                                                        <div className="form-floating">
                                                            <h3>
                                                                <b>Vendor Rating</b>
                                                            </h3>

                                                            <Button
                                                                className="btn rateNowblue_btn custom_btn"
                                                                onClick={() => {
                                                                    handleShowRatingModal();
                                                                    setedit(true);
                                                                    handelViewModel(false);
                                                                }}
                                                            >
                                                                Rate vendor
                                                            </Button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    ''
                                                )
                                            ) : viewdata?.rating_appUser !== null ? (
                                                <>
                                                    <>
                                                        <div className="col-sm-12">
                                                            <div
                                                                className="form-floating"
                                                                style={{ marginBottom: '20px' }}
                                                            >
                                                                <h3 style={{ marginBottom: '0px' }}>
                                                                    <b>Vendor Rating</b>
                                                                </h3>
                                                                <ReactStars
                                                                    count={5}
                                                                    value={viewdata?.rating_appUser?.rating}
                                                                    size={25}
                                                                    isHalf={true}
                                                                    edit={false}
                                                                    activeColor="#ffd700"
                                                                />
                                                            </div>

                                                            <div className="form-floating">
                                                                {viewdata?.rating_appUser?.remark && (
                                                                    <div className="form-floating">
                                                                        <input
                                                                            id="remarks"
                                                                            className="form-control"
                                                                            placeholder="Remark"
                                                                            value={viewdata?.rating_appUser?.remark}
                                                                            disabled={true}
                                                                        />
                                                                        <label htmlFor="floatingInput">Remarks</label>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    )}
                                </form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                )}

                {demandModel && (
                    <OtherDemandView
                        data={viewdata}
                        showModel={true}
                        demanModelCallback={() => {
                            setDemandModel(false);
                        }}
                    />
                )}

                {showHideModel && (
                    <Modal show={true} onHide={() => handlereset()} backdrop="static" keyboard={false}>
                        <Modal.Header closeButton>
                            <Modal.Title> {'Update Status'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{edit && deliveryModel()}</Modal.Body>
                        <Modal.Footer>
                            {bidData == 'delivered' || bidData == 'notArrived' ? (
                                <></>
                            ) : (
                                <>
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={() => {
                                            updateBidStatus();
                                        }}
                                    >
                                        Save
                                    </Button>

                                    <Button
                                        variant="default"
                                        className="btn custom_btn border_btn with_icon"
                                        onClick={() => {
                                            handlereset();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </>
                            )}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}
